/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import ExpandablePanel from 'components/ExpandablePanel';
import styles from './styles';
import useTranslate, {
  useMarkdownTranslate,
} from 'hooks/useTranslate/useTranslate';
import { InstallmentOfferData } from '../Offer/CheckoutOffer/InstallmentCheckout';
import { conformToMask, decimalMoneyMask } from 'utils/masks';
import { SplitPayOfferData } from '../Offer/SplitPay';

interface PropTypes {
  splitPayOfferData?: SplitPayOfferData;
  installmentOfferData?: InstallmentOfferData;
}

const PaymentPlan: React.FC<PropTypes> = props => {
  const { splitPayOfferData, installmentOfferData: installmentData } = props;

  const t = useTranslate();

  const tMd = useMarkdownTranslate();

  return (
    <ExpandablePanel
      title={
        <span css={styles.panelText}>
          <img
            css={styles.panelIcon}
            src={`data:image/png;base64,${t(
              'unified.placeOrder.label.paymentIcon',
            )}`}
            alt="Payment"
          />
          <p css={styles.panelTitle}>
            {t('unified.placeOrder.label.paymentPlan')}
          </p>
          {splitPayOfferData && (
            <p css={styles.panelSecondaryText}>
              {tMd('unified.offer.paymentOption.splitPay.description', {
                amount: conformToMask(
                  splitPayOfferData.biweeklyPayment.toFixed(2),
                  decimalMoneyMask,
                ),
                termLength: splitPayOfferData.termLength,
              })}
            </p>
          )}
          {installmentData && (
            <p css={styles.panelSecondaryText}>
              {`
              ${conformToMask(
                installmentData.perMonth.toFixed(2),
                decimalMoneyMask,
              )}
              /mo* for ${installmentData.termLength} months`}
            </p>
          )}
        </span>
      }
      panelName={'paymentPlan'}
    >
      {splitPayOfferData && (
        <div>
          {tMd('unified.offer.paymentOption.splitPay.description', {
            amount: conformToMask(
              splitPayOfferData.biweeklyPayment.toFixed(2),
              decimalMoneyMask,
            ),
            termLength: splitPayOfferData.termLength,
          })}
        </div>
      )}

      {installmentData && (
        <div>
          <div css={styles.panelText}>
            <p css={styles.panelTotalTitle}>Installments:</p>
          </div>
          <p>{`
              ${conformToMask(
                installmentData.perMonth.toFixed(2),
                decimalMoneyMask,
              )}
              /mo* for ${installmentData.termLength} months`}</p>
          <p css={styles.panelFinePrint}>{`Interest cost: ${conformToMask(
            installmentData.interest.toFixed(2),
            decimalMoneyMask,
          )}`}</p>
          <p css={styles.panelFinePrint}>{`Total cost: ${conformToMask(
            installmentData.total.toFixed(2),
            decimalMoneyMask,
          )}`}</p>
        </div>
      )}
    </ExpandablePanel>
  );
};

export default PaymentPlan;
